import { render } from "./SharedRewards.vue?vue&type=template&id=5b52e53e"
import script from "./SharedRewards.vue?vue&type=script&lang=js"
export * from "./SharedRewards.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__